import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Gift } from "lucide-react";

interface FreeTrialCardProps {
  onSubscribe: (plan: string) => void;
}

export const FreeTrialCard = ({ onSubscribe }: FreeTrialCardProps) => {
  return (
    <Card className="p-6 bg-gradient-to-r from-primary/10 to-primary/5 border-primary/20">
      <div className="flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-4">
          <div className="p-3 bg-primary/10 rounded-full">
            <Gift className="w-6 h-6 text-primary" />
          </div>
          <div>
            <h3 className="text-xl font-semibold">14 Day Free Trial</h3>
            <p className="text-muted-foreground mt-1">
              Try all Premium features free for 14 days
            </p>
          </div>
        </div>
        <Button 
          size="lg"
          onClick={() => onSubscribe("Freemium (Free Trial)")}
          className="w-full md:w-auto bg-primary hover:bg-primary/90"
        >
          Start Free Trial
        </Button>
      </div>
    </Card>
  );
};